import Marquee from "react-fast-marquee";

const WORDS = ["PREMIUM QUALITY", "FRESH DAILY", "HONEST TRADING", "KARNAVATI MARKET", "BULK SUPPLY", "COMMISSION AGENT"];

export default function EditorialMarquee({ dark = false }) {
  return (
    <div className={`py-8 border-y ${dark ? "border-white/10 bg-brand-forest" : "border-brand-forest/10 bg-brand-sand"}`}>
      <Marquee speed={28} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className={`font-display text-5xl md:text-7xl tracking-tight ${dark ? "text-white/15" : "text-brand-forest/15"}`}>
              {w}
            </span>
            <span className="mx-10 text-brand-terra text-3xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
